import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/calcom/apps/web/modules/auth/forgot-password/forgot-password-view.tsx");
